// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".qzZnP {\n  visibility: hidden;\n  width: 0;\n  height: 0;\n  position: absolute;\n  z-index: -1;\n  top: -9999px;\n}\n\n._8cauL {\n  /* Aligns with Button component used for student demo mode */\n  padding: var(--space-100) var(--space-200);\n  border-radius: var(--radius-100);\n  border: 1px solid var(--border-color-accent);\n  height: var(--space-500);\n}\n\n._8cauL:hover {\n    background-color: var(--surface-brand-hover);\n  }\n\n.ELnyl {\n  max-height: var(--space-1500);\n  overflow: auto !important;\n}\n\n._3a5G- {\n  padding: unset !important;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": "qzZnP",
	"anchorContainer": "_8cauL",
	"menuContainer": "ELnyl",
	"anchorButton": "_3a5G-"
};
export default ___CSS_LOADER_EXPORT___;
